import { Injectable } from '@angular/core';
import { ISession } from '../../typings';

export enum SESSION_TYPE {
     INTERNAL = 0,
     EXTERNAL = 1,
}

export interface ISessionStorage {
     connectionType: SESSION_TYPE;
     session: ISession;
}

@Injectable()
export class SessionService {
     private storageKey = 'htz-ob-plg-sess-key';
     connectionType: SESSION_TYPE;

     constructor() {
          this.get();
     }

     set(session: ISession, type: SESSION_TYPE) {
          this.connectionType = type;
          localStorage.setItem(
               this.storageKey,
               JSON.stringify({
                    connectionType: type,
                    session,
               })
          );
     }

     get(): ISession {
          const d = localStorage.getItem(this.storageKey);
          let dObj: ISessionStorage;

          if (d) {
               try {
                    dObj = JSON.parse(d) as any;
                    this.connectionType = dObj.connectionType;
               } catch (e) {
                    dObj = null;
               }
          }
          return dObj && dObj.session;
     }

     clear() {
          localStorage.removeItem(this.storageKey);
     }

     getToken() {
          let sess = this.get() as any;
          if (!sess) {
               return void 0;
          }
          return sess.idSession;
     }

     answerInitialQuestion() {
          const sess = this.get();
          if (sess) {
               sess.initialQuestionAnswered = true;
               this.set(sess, this.connectionType);
          }
     }

     isInitialQuestionAnswered() {
          const sess = this.get();
          return !!(sess && sess.initialQuestionAnswered);
     }
}
